import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { ChevronLeft, ChevronRight, Calendar, MapPin } from "lucide-react";
import Header from "../../layouts/header";
import images from "../../constant/images";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function EventsCalendar() {
  const baseUrl = useSelector((state) => state.gtm.baseUrl);
  const defaultColor = useSelector((state) => state.gtm.defaultColor);

  const [user, setUser] = useState(null);
  const [member, setMember] = useState(null);
  const [pack, setPack] = useState(null);
  const [events, setEvents] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isEventsLoading, setIsEventsLoading] = useState(true);
  const navigate = useNavigate();

  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  const language = localStorage.getItem("i18nextLng");

  console.log(events?.event_type?.color , 'wwwwwwwwwwwwww');
  

  const getEventTypeColor = (event) => {
    return (
      event?.golf_event_type?.color || event?.event_type?.color || "#6eea6c"
    );
  };

  const getEventTypeName = (event) => {
    return event?.golf_event_type?.name || event?.event_type?.name || "Event";
  };

  // Format month display
  const formatMonth = (date) => {
    const monthNames =
      language === "fr"
        ? [
            "Janvier",
            "Février",
            "Mars",
            "Avril",
            "Mai",
            "Juin",
            "Juillet",
            "Août",
            "Septembre",
            "Octobre",
            "Novembre",
            "Décembre",
          ]
        : [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];

    return `${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };

  // Filter events by current month
  const filterEventsByMonth = (events, month) => {
    return events.filter((event) => {
      const eventDate = new Date(event.date);
      return (
        eventDate.getMonth() === month.getMonth() &&
        eventDate.getFullYear() === month.getFullYear()
      );
    });
  };

  // Navigate to previous month
  const goToPreviousMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    setCurrentMonth(newMonth);
  };

  // Navigate to next month
  const goToNextMonth = () => {
    const newMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    setCurrentMonth(newMonth);
  };

  // Update filtered events when currentMonth changes
  useEffect(() => {
    if (events.length > 0) {
      const filtered = filterEventsByMonth(events, currentMonth);
      setFilteredEvents(filtered);
      console.log(
        `Filtered events for ${formatMonth(currentMonth)}:`,
        filtered.length
      );
    }
  }, [currentMonth, events]);

  const fetchData = useCallback(async () => {
    const token = localStorage.getItem("userToken");
    try {
      if (token) {
        const response = await axios.get(`${baseUrl}/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUser(response.data);

        if (response.data?.membership?.status === "valid") {
          setMember(response.data.membership);
          setPack(response.data.membership?.membership_packs);
        }
      }
    } catch (error) {
      console.log("Error fetching user:", error);
    } finally {
      setIsLoading(false);
    }
  }, [baseUrl]);

  const fetchEvents = useCallback(async () => {
    try {
      setIsEventsLoading(true);
      const res = await axios.get(`${baseUrl}/golf_events`);
      console.log("Events API response:", res.data);

      let eventsData = [];
      let typesData = [];

      if (res.data.events) {
        eventsData = res.data.events;
      }

      if (res.data.types) {
        typesData = res.data.types;
      }

      setEvents(eventsData);
      setEventTypes(typesData);

      // Filter events for current month
      const filtered = filterEventsByMonth(eventsData, currentMonth);
      setFilteredEvents(filtered);

      console.log("Total events loaded:", eventsData.length);
      console.log("Event types loaded:", typesData.length);
      console.log("Filtered events for current month:", filtered.length);
    } catch (error) {
      console.log("Error fetching events:", error);
    } finally {
      setIsEventsLoading(false);
    }
  }, [baseUrl, currentMonth]);

  useEffect(() => {
    fetchData();
    fetchEvents();

    return () => {
      setUser(null);
      setMember(null);
      setPack(null);
      setEvents([]);
      setEventTypes([]);
      setFilteredEvents([]);
      setIsEventsLoading(true);
      setIsLoading(true);
    };
  }, [fetchData, fetchEvents]);

  const formatMonthName = (month) => {
    switch (month) {
      case "01":
        return language === "fr" ? "Janvier" : "January";
      case "02":
        return language === "fr" ? "Février" : "February";
      case "03":
        return language === "fr" ? "Mars" : "March";
      case "04":
        return language === "fr" ? "Avril" : "April";
      case "05":
        return language === "fr" ? "Mai" : "May";
      case "06":
        return language === "fr" ? "Juin" : "June";
      case "07":
        return language === "fr" ? "Juillet" : "July";
      case "08":
        return language === "fr" ? "Août" : "August";
      case "09":
        return language === "fr" ? "Septembre" : "September";
      case "10":
        return language === "fr" ? "Octobre" : "October";
      case "11":
        return language === "fr" ? "Novembre" : "November";
      case "12":
        return language === "fr" ? "Décembre" : "December";
      default:
        return language === "fr" ? "Mois invalide" : "Invalid Month";
    }
  };

  if (isLoading || isEventsLoading) {
    <div className="flex justify-center items-center h-64">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
    </div>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header image={images.about} title="2025 National Golf Events" />

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-3xl shadow-lg overflow-hidden">
          <div className="p-6 sm:p-8">


            {/* Event Types Legend */}
            {eventTypes.length > 0 && (
              <div className="mb-8 p-4 sm:p-6 bg-gray-50 rounded-xl">
                <h3 className="text-sm sm:text-base font-semibold text-gray-700 mb-4">
                  {language === "fr" ? "Types d'événements:" : "Event Types:"}
                </h3>
                <div className="flex flex-wrap gap-3 sm:gap-4">
                  {eventTypes.map((eventType) => (
                    <div
                      key={eventType.id}
                      className="flex items-center space-x-2"
                    >
                      <div
                        className="w-4 h-4 rounded-full flex-shrink-0"
                        style={{ backgroundColor: eventType.color }}
                      />
                      <span className="text-xs sm:text-sm text-gray-600">
                        {eventType.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Month Navigation */}
            <div className="flex items-center justify-between mb-8 px-4 sm:px-8">
              <button
                onClick={goToPreviousMonth}
                className="p-2 sm:p-3 hover:bg-gray-100 rounded-lg transition-colors border border-gray-200"
              >
                <ChevronLeft className="h-5 w-5 sm:h-6 sm:w-6 text-gray-600" />
              </button>

              <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 text-center">
                {formatMonth(currentMonth)}
              </h2>

              <button
                onClick={goToNextMonth}
                className="p-2 sm:p-3 hover:bg-gray-100 rounded-lg transition-colors border border-gray-200"
              >
                <ChevronRight className="h-5 w-5 sm:h-6 sm:w-6 text-gray-600" />
              </button>
            </div>

            {/* Events Section */}
            <div className="space-y-4 sm:space-y-6">
              {filteredEvents.length > 0 ? (
                <div className="space-y-4 max-h-96 sm:max-h-[500px] overflow-y-auto px-2">
                  {filteredEvents.map((item) => (
                    <div
                      key={item.id}
                      className="bg-green-50 hover:shadow-lg transition-all duration-200 cursor-pointer relative overflow-hidden rounded-xl border border-green-100"
                      onClick={
                        isLoading
                          ? null
                          : () => {
                              if (item.golf_event_type) {
                                const navState = {
                                  eventId: item.id,
                                };
                                navigate("/gtmclub/calendar/show_events", {
                                  state: navState,
                                });
                              } else {
                                const navState = {
                                  isGolfer: user?.golfeurs,
                                  eventId: item.id,
                                  pack: pack?.name,
                                  memberId: member?.id,
                                  membershipId: member?.membership_id,
                                };
                                console.log("navStategggggggggggg", navState);

                                navigate("/gtmclub/2025program/show_events", {
                                  state: navState,
                                });
                              }
                            }
                      }
                    >
                      {item.sold_out === 1 && (
                        <div className="absolute top-0 right-0 z-10">
                          <img
                            src="/placeholder.svg?height=130&width=130"
                            alt="sold out"
                            className="h-24 w-24 sm:h-32 sm:w-32"
                          />
                        </div>
                      )}

                      <div className="p-4 sm:p-6">
                        <div className="flex justify-between items-start gap-4">
                          <div className="flex-1 min-w-0">
                            <h4 className="font-bold text-sm sm:text-base lg:text-lg mb-2 line-clamp-2 text-gray-800">
                              {item.title || item.name}
                            </h4>
                            {(item.details || item.description) && (
                              <p className="text-xs sm:text-sm text-gray-600 mb-3 line-clamp-2">
                                {item.details || item.description}
                              </p>
                            )}
                            {(item.venue || item.location) && (
                              <div className="flex items-center space-x-1">
                                <MapPin className="h-3 w-3 sm:h-4 sm:w-4 text-red-500 flex-shrink-0" />
                                <span className="text-xs sm:text-sm text-blue-600 font-medium truncate">
                                  {item.venue || item.location}
                                </span>
                              </div>
                            )}
                          </div>

                          <div className="flex items-center space-x-2 sm:space-x-3 flex-shrink-0">
                            <div className="text-right">
                              <div className="text-sm sm:text-base lg:text-lg font-bold text-gray-800">
                                {item.hide_date !== 1 &&
                                  item.date.split("-")[2]}
                              </div>
                              <div className="text-sm sm:text-base lg:text-lg font-bold text-gray-800">
                                {formatMonthName(item.date.split("-")[1])}
                              </div>
                            </div>
                            {item.hide_date !== 1 && (
                              <Calendar className="h-6 w-6 sm:h-7 sm:w-7 lg:h-8 lg:w-8 text-gray-800" />
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Bottom colored bar */}
                      <div
                        className="h-3 sm:h-4 w-full"
                        style={{ backgroundColor: getEventTypeColor(item) }}
                      />
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12 sm:py-16">
                  <Calendar className="h-12 w-12 sm:h-16 sm:w-16 text-gray-400 mx-auto mb-4" />
                  <p className="text-gray-500 text-sm sm:text-base">
                    {language === "fr"
                      ? "Aucun événement prévu pour ce mois"
                      : "No events scheduled for this month"}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
